// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/SessionAndPatientDetail/sessionPatientDetail.css
// module id = 839
// module chunks = 1